import React from "react";
import {
  TableRow,
  TableCell,
  Dialog,
  Slide,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { tableCellClasses } from "@mui/material/TableCell";
import TabsListUnstyled from "@mui/lab/TabList";
import {
  buttonClasses as buttonUnstyledClasses,
} from "@mui/material/Button";
import TabUnstyled, {
  tabClasses as tabUnstyledClasses,
} from "@mui/material/Tab";
import { ColorPallet } from "../../utils/colorPallet";

import { TransitionProps } from "@mui/material/transitions";

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: ColorPallet.neutralLightGrey,
    borderBottom: "1px solid #DDDDDD",
    paddingTop: "2px",
    paddingBottom: "2px",
    paddingLeft: "8px",
  },
  [`&.${tableCellClasses.body}`]: {
    borderBottom: "1px solid #DDDDDD",
    paddingTop: "2px",
    paddingBottom: "2px",
    paddingLeft: "8px",
  },
}));

export const StyledTableCell2 = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: ColorPallet.neutralLightGrey,
    borderBottom: "1px solid #DDDDDD",
    
  },
  [`&.${tableCellClasses.body}`]: {
    backgroundColor: ColorPallet.neutralLightGrey,
    borderBottom: "1px solid #DDDDDD", 
  },
}));

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

export const Tab = styled(TabUnstyled)`
  cursor: pointer;
  color: #65748b;
  font-weight: bold;
  padding: 12px 30px;
  display: flex;
  justify-content: center;
  border: none;
  border-top: 1px solid #ccc;
  border-right: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
  background-color: #fff;

  &:hover {
    background-color: BackGroundColor.backgroundcolor;
  }

  &.${tabUnstyledClasses.selected} {
    background-color: white;
    color: white;
    border-bottom: none;
    color: #121828;
  }

  &.${buttonUnstyledClasses.disabled} {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const TabsList = styled(TabsListUnstyled)(({ theme }) => ({
  display: "flex",
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
  },
}));

export const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});